import ProductsTable from './ProductsTable'

export default ProductsTable
